/* eslint-disable eqeqeq */
import {
    REFRESH_ASSETS,
    REMOVE_ASSET,
    SELECT_ASSET,
    FOLLOW_ASSET,
    UPDATE_ASSETS
  } from '../constants';
  
  const DEFAULT_STATE = {
    assets: {},
    asset: null,
    follow: null,
    stop: 0,
    initFolSpeed: {},
  };
  
  const AssetsReducer = (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
      case REFRESH_ASSETS:
        state.assets = {};
        payload.forEach((asset) => (state.assets[asset.id] = asset));
        return {
          ...state,
        };
      case UPDATE_ASSETS:
        payload.forEach((asset) => (state.assets[asset.id] = asset));
        return {
          ...state,
        };
      case SELECT_ASSET:
        return {
          ...state,
          asset: payload,
        };
      case FOLLOW_ASSET:
        return {
          ...state,
          follow: payload,
        };
      case REMOVE_ASSET:
        delete state.assets[payload];
        return {
          ...state,
        };
      default:
        return state;
    }
  };
  
  export default AssetsReducer;